import React, { useContext, useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import { toast } from 'react-toastify'
import { format } from 'date-fns'

import { Button, Select, Textbox } from '../../../../components/Form'
import { AssociacaoContext } from '../../../../contexts/AssociacaoContext'
import formUtils from '../../../../util/form'
import masks from '../../../../util/masks'
import Yup from '../../../../services/yup'
import { validarCPF } from '../../../../util/validadores'
import { AvatarContext } from '../../../../contexts/AvatarContext'
import { GlobalContext } from '../../../../contexts/GlobalContext'

const baseInitialValues = {
    nome: '',
    cpf: '',
    email: '',
    data_nascimento: '',
    sexo: null,
    celular: ''
}

const validation = Yup.object({
    nome: Yup.string().required('Informe seu nome completo e sem abreviações.'),
    cpf: Yup.string().required('Informe seu CPF.')
        .test('validar-cpf', 'CPF inválido.', value => validarCPF(value || '')),
    email: Yup.string().required('Informe seu email.'),
    data_nascimento: Yup.string().date().required('Informe sua data de nascimento.'),
    sexo: Yup.object({ label: Yup.string(), value: Yup.mixed() }).required('Selecione o sexo.'),
    celular: Yup.string().required('Informe seu número de celular.(WhatsApp)')
})

export function Pessoal() {
    const { clienteRobot } = useContext(GlobalContext)
    const {
        tempData, syncTempData, sincronizarDadosTemporarios, avancarEtapa
    } = useContext(AssociacaoContext)
    const { handleSpeak } = useContext(AvatarContext)

    const [initialValues, setInitialValues] = useState(baseInitialValues)

    function handleSubmit(values) {
        const data = formUtils.extractFormValues(values)

        syncTempData(data)

        avancarEtapa()
    }

    async function tratarDadosAPartirDoCPF(cpf, setFieldValue) {
        if(validarCPF(cpf)) {
            // const cpfSemMascara = e.target.value.replace(/[^\d]+/g, '')

            // const { data: response } = await cpfApi.get(cpfSemMascara)

            // setFieldValue('nome', response.nome)
            
            sincronizarDadosTemporarios(cpf)
        } else {
            toast.warn('CPF inválido!')

            setFieldValue('cpf', '')
            setFieldValue('nome', '')
        }
    }

    useEffect(() => {
        if (!tempData.cpf) {
            return
        }

        const {
            nome, cpf, celular, email, data_nascimento, sexo
        } = tempData

        setInitialValues({
            nome,
            cpf,
            data_nascimento: format(new Date(data_nascimento), 'dd/MM/yyyy'),
            sexo: {
                label: sexo === 'M' ? 'Masculino' : 'Feminino',
                value: sexo
            },
            celular,
            email
        })
    }, [tempData])

    useEffect(() => {
        handleSpeak(`Seja bem-vindo à associação ${clienteRobot.name}! Comece informando sua matrícula.`)
    }, [])

    return (
        <div>
            <Formik
                onSubmit={handleSubmit}
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validation}
            >
                {({ setFieldValue }) => (
                    <Form className="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-4">
                        <Textbox
                            name="cpf"
                            label="CPF"
                            mask={masks.cpf}
                            inputMode="numeric"
                            onBlur={e => {
                                const cpf = e.target.value

                                tratarDadosAPartirDoCPF(cpf, setFieldValue)
                            }}
                        />

                        <Textbox
                            name="nome"
                            label="Nome"
                        />

                        <Select
                            name="sexo"
                            label="Sexo"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Masculino', value: 'M' },
                                { label: 'Feminino', value: 'F' }
                            ]}
                            isSearchable={false}
                        />

                        <Textbox
                            name="data_nascimento"
                            label="Data de nascimento"
                            inputMode="numeric"
                            mask={masks.date}
                        />

                        <Textbox
                            name="email"
                            label="E-mail"
                        />

                        <Textbox
                            name="celular"
                            label="Celular (Whatsapp)"
                            mask={masks.mobile}
                        />

                        <div className="sm:col-span-2 md:col-span-4 flex justify-end mt-3 border-t border-gray-300 pt-3">
                            <Button type="submit" className="transparent w-full sm:w-fit">
                                Continuar
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
} 
